import { cx } from '@linaria/core';
import { Fragment } from 'react';
import { getCaptionValue } from '@pm2/content-engine';
import { spanCls, titleCls, scrambleCls, subCaptionCls, descriptionCls, captionCls } from './styles/Caption.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const PUNCTUATION_REGEX = /[.,!?]\s*$/;
function Caption(props) {
  if (!props.caption) {
    return null;
  }
  const content = extractCaptionContent(props.caption);
  const subCaptionLabels = [!!content.caption && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.caption
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.caption)
  }), !!content.authorOrArtist && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.authorOrArtist
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.authorOrArtist)
  }), !!content.year && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.year
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.year)
  }), !!content.copyright && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.copyright
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.copyright)
  }), !!content.country && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.country
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.country)
  }), !!content.duration && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.duration
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.duration)
  }), !!content.numberOfPages && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: content.numberOfPages
    },
    "data-comma": !PUNCTUATION_REGEX.test(content.numberOfPages)
  })].filter(it => !!it);
  return /*#__PURE__*/jsxs("div", {
    className: cx(captionCls, props.scrambled && "scrambled"),
    children: [!!content.title && /*#__PURE__*/jsx("h3", {
      className: cx(titleCls, scrambleCls),
      children: /*#__PURE__*/jsx("span", {
        dangerouslySetInnerHTML: {
          __html: content.title
        }
      })
    }), subCaptionLabels.length > 0 && /*#__PURE__*/jsx("div", {
      className: cx(subCaptionCls, scrambleCls),
      children: subCaptionLabels.map((label, index) => /*#__PURE__*/jsxs(Fragment, {
        children: [label, index < subCaptionLabels.length - 1 && (label.props["data-comma"] === true ? ", " : " ")]
      }, index))
    }), content.description && /*#__PURE__*/jsx("span", {
      className: cx(descriptionCls, scrambleCls),
      dangerouslySetInnerHTML: {
        __html: content.description
      }
    })]
  });
}
function extractCaptionContent(caption) {
  return Object.fromEntries(Object.entries(caption).map(([key, property]) => [key, getCaptionValue(property)]));
}

export { Caption };
//# sourceMappingURL=Caption.js.map
